"use client";
import { jsx as c } from "react/jsx-runtime";
import { Container as p, sharedHandler as d } from "@ingeniorforeningen/figurine-core";
import { forwardRef as f } from "react";
import { resolveSize as x, PADDING_SIZES as e } from "./Container.helpers.js";
import '../../../assets/Container.css';const C = "_root_17v5e_2", N = {
  root: C
}, o = f((r, s) => {
  const { children: a, className: t, size: l = "xl", style: n, ...i } = r, m = x(l);
  return /* @__PURE__ */ c(
    p,
    {
      ...i,
      ref: s,
      className: `${N.root} ${t}`,
      size: m,
      style: n,
      pl: { base: e.base, lg: e.lg, xl: e.xl },
      pr: { base: e.base, lg: e.lg, xl: e.xl },
      children: a
    }
  );
});
o.displayName = "Container";
const y = d(o);
y.displayName = o.displayName;
export {
  N as C,
  o as _Container,
  y as default
};
